/** @jsxImportSource theme-ui */
import { Box, Grid, Label, Text } from "@bottlebooks/gatsby-design-system";
import { Trans } from "@lingui/macro";
import { MapPin } from "@phosphor-icons/react";
import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import Skeleton from "../Skeleton";

type MeetingLocationProps = Omit<
  ComponentPropsWithoutRef<typeof Grid>,
  "children" | "sx"
> & {
  location: string | null | undefined;
  label?: ReactNode;
  as?: ElementType;
};
export default function MeetingLocation({
  location,
  label = <Trans>Location</Trans>,
  ...rest
}: MeetingLocationProps) {
  if (!location) return null;
  return (
    <Grid
      sx={{ gridTemplateColumns: "16px auto", columnGap: 2, rowGap: 0 }}
      {...rest}
    >
      <MapPin size={16} weight="light" sx={{ marginTop: 0.5 }} />
      <Box>
        {label && (
          <Label variant="small" sx={{ color: "inherit", fontWeight: "bold" }}>
            {label}
          </Label>
        )}
        <Text variant="smallest">{location}</Text>
      </Box>
    </Grid>
  );
}

export function MeetingLocationSkeleton({
  label = <Trans>Location</Trans>,
  ...rest
}: Omit<MeetingLocationProps, "location">) {
  return (
    <Grid
      sx={{ gridTemplateColumns: "16px auto", columnGap: 2, rowGap: 0 }}
      {...rest}
    >
      <MapPin size={16} weight="light" sx={{ marginTop: 0.5 }} />
      <Box>
        {label && (
          <Label variant="small" sx={{ color: "inherit", fontWeight: "bold" }}>
            {label}
          </Label>
        )}
        <Text variant="smallest" sx={{ paddingBottom: 1 }}>
          <Skeleton width="8em" height="1em" />
        </Text>
      </Box>
    </Grid>
  );
}
